import React from 'react';
import PropTypes from 'prop-types';
import PaytmIcon from '../../atoms/icons/paytm';
import SimplIcon from '../../atoms/icons/simpl';
import Loader from '../../atoms/icons/loader';
import { syndicatedSource, checkStoryType } from '../../../helpers/utils';
import { sendProductDetail, trackAddToCart } from '../../../helpers/datalayer-utils';
import './micro-payment.m.css';

class PaymentOptions extends React.Component {
  constructor(props) {
    super(props);
    this.addToCart = this.addToCart.bind(this);
  }
  componentDidMount() {
    this.props.setUser();
    const datalayerFields = {
      name: this.props.assetPlan?.duration_unit,
      id: this.props.assetPlan?.id,
      price: this.props.assetPlan?.price_cents / 100,
      brand: this.props.story['story-template'] || 'text',
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
      dimension7: 'NA',
      dimension11: 'Logged In',
      dimension12: 'Banner',
      dimension13: 'Bottom Sticky',
      dimension14: 'NA',
      dimension15: `${this.props.story.headline}`,
      dimension16: this.props.story['story-template'] || 'text',
      dimension17: this.props.story['sections'][0].name,
      dimension18: 'NA',
      dimension19: this.props.story['author-name'],
      dimension20: (this.props.story.tags || []).map((t) => t.name).join(' | '),
      dimension21: syndicatedSource(this.props.story),
    };
    // sendProductDetail(datalayerFields);
  }

  addToCart() {
    const datalayerFields = {
      name: this.props.assetPlan.duration_unit,
      id: this.props.assetPlan.id,
      price: this.props.assetPlan.price_cents / 100,
      brand: this.props.story['story-template'] || 'text',
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
      dimension7: 'NA',
      dimension11: 'Logged In',
      dimension12: 'Banner',
      dimension13: 'Bottom Sticky',
      dimension14: 'NA',
      dimension15: `${this.props.story.headline}`,
      dimension16: this.props.story['story-template'] || 'text',
      dimension17: this.props.story['sections'][0].name,
      dimension18: 'NA',
      dimension19: this.props.story['author-name'],
      dimension20: (this.props.story.tags || []).map((t) => t.name).join(' | '),
      dimension21: syndicatedSource(this.props.story),
    };
    trackAddToCart(datalayerFields);
  }

  render() {
    return (
      <div styleName="story-subscribe-wrap">
        <div styleName="story-subscribe">
          <div styleName="align">
            <h3 styleName="subscribe-headline">Choose your payment method</h3>
            <p styleName="subscribe-summary">
              For a hassle-free payment experience, simply link your account once and pay in just
              two clicks.
            </p>
            {this.props.isLoading ? (
              <div styleName="loader">
                <Loader color={'#000'} />
              </div>
            ) : (
              <div styleName="subscribe-buttons">
                {this.props.paymentOptions && this.props.paymentOptions.paytm && (
                  <div styleName="pay-btn-group pay-btn-group-paytm">
                    <span styleName="wallet-icon">
                      <PaytmIcon />
                    </span>
                    <button
                      onClick={(event) => {
                        event.target.disabled = true;
                        this.props.payment('paytm');
                        this.addToCart();
                      }}
                      styleName="paywall-button pay-btn paytm-btn"
                    />
                  </div>
                )}
                {this.props.paymentOptions && this.props.paymentOptions.simpl && (
                  <div styleName="pay-btn-group pay-btn-group-simpl">
                    <span styleName="wallet-icon">
                      <SimplIcon />
                    </span>
                    <button
                      onClick={() => {
                        this.props.payment('simpl');
                        this.addToCart();
                      }}
                      styleName="paywall-button pay-btn simpl-btn"
                    />
                  </div>
                )}
              </div>
            )}
            <span styleName="paywall-footer">
              To change your number{' '}
              {this.props.mobileNumber && (
                <span styleName="paywall-footer-mobile">{this.props.mobileNumber},</span>
              )}
              <a onClick={() => this.props.changeNumber('Update')} styleName="paywall-footer-link">
                Click here
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

PaymentOptions.propTypes = {
  changeNumber: PropTypes.func.isRequired,
  payment: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  paymentOptions: PropTypes.objectOf(PropTypes.any).isRequired,
  mobileNumber: PropTypes.string,
  assetPlan: PropTypes.shape({
    price_cents: PropTypes.number,
    price_currency: PropTypes.string,
    duration_unit: PropTypes.string,
    id: PropTypes.string,
  }),
  story: PropTypes.shape({
    'story-template': PropTypes.string,
    headline: PropTypes.string,
    sections: PropTypes.array,
    tags: PropTypes.array,
    'author-name': PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
};

PaymentOptions.defaultProps = {
  mobileNumber: '',
};

export default PaymentOptions;
